
export default function Internship() {
  return (
    <section id="jobs" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
          Stage
        </h2>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Société Smart Car Services
              </h3>
              <p className="text-gray-600">Du 01/08/2021 au 30/08/2021</p>
            </div>

            <div className="space-y-2">
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-3 flex-1">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-500 text-white rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-briefcase-fill text-xl"></i>
                  </div>
                  <div className="flex-1">
                    <span className="font-semibold text-gray-900 block">
                      Stage au sein du magasin de la société Smart Car Services
                    </span>
                    <a
                      href="https://justenjay1234.github.io/fouedieua/stage.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-700 text-sm inline-flex items-center gap-1 mt-1 cursor-pointer whitespace-nowrap"
                    >
                      Voici Le Certificat
                      <i className="ri-external-link-line"></i>
                    </a>
                  </div>
                </div>
                <span className="font-bold text-gray-900 whitespace-nowrap">75%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                <div
                  className="h-full bg-blue-500 rounded-full transition-all duration-1000"
                  style={{ width: '75%' }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
